import styled from "styled-components";
import Achievement from "./Achievement";
import VgcDor from "./VcgDor";
import { useUser } from "../../../context/useUser";
import { FC } from "react";

const Achievements: FC = ({}) => {

  const { user } = useUser();

  return (
    <Container className="gradient-gray">
      { user ?
          <>
      {/* vgc d'or small screens*/}
      <DisplaySmall>
        <div className="row d-flex justify-content-center align-items-center mt-5">
          <div className="col-4">
            <Achievement
              quantity={user?.trophies?.vgcdOr || 0}
              achievement="vgcdOr"
            />
          </div>
        </div>
      </DisplaySmall>

      {/*  divisions won achivements */}
      <div className="row mt-5 mt-md-5 mt-lg-5">
        <div className="col-12 col-lg-6">
          <div className="row ">
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionOne || 0}
                achievement="divisionOne"
              />
            </div>
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionTwo || 0}
                achievement="divisionTwo"
              />
            </div>
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionThree || 0}
                achievement="divisionThree"
              />
            </div>
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionFour || 0}
                achievement="divisionFour"
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 mt-3 mt-md-0">
          <div className="row ">
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionFive || 0}
                achievement="divisionFive"
              />
            </div>
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionSix || 0}
                achievement="divisionSix"
              />
            </div>
            <div className="col-3 mt-2 mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionSeven || 0}
                achievement="divisionSeven"
              />
            </div>
            <div className="col-3 mt-2  mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.divisionEight || 0}
                achievement="divisionEight"
              />
            </div>
          </div>
        </div>
      </div>

      {/*  accolades won achivements */}
      <div className="row d-flex justify-content-center  mt-5 mt-md-5 mt-lg-5">
        <div className="col-12 col-lg-4 ">
          <div className="row d-flex justify-content-center">
            <div className="col-3 mt-2 col-lg-5 ">
              <Achievement
                quantity={user?.trophies?.goldenBoot || 0}
                achievement="goldenBoot"
              />
            </div>
            <div className="col-3 mt-2 col-lg-5">
              <Achievement
                quantity={user?.trophies?.mostTackles || 0}
                achievement="mostTackles"
              />
            </div>
            <div className="col-3 mt-2 col-lg-5 mt-lg-3">
              <Achievement
                quantity={user?.trophies?.goldenGlove || 0}
                achievement="goldenGlove"
              />
            </div>
            <div className="col-3 mt-2 col-lg-5 mt-lg-3">
              <Achievement
                quantity={user?.trophies?.mostPasses || 0}
                achievement="mostPasses"
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-2 d-flex justify-content-center align-items-center">
          <div className="row ">
            {/* vgc d'or large screens*/}
            <DisplayLarge>
              <div className="row ">
                <div className="col-4 h-100 w-100">
                  <VgcDor
                    quantity={user?.trophies?.vgcdOr || 0}
                    achievement="vgcdOr"
                  />
                </div>
              </div>
            </DisplayLarge>
          </div>
        </div>
        <div className="col-12 col-lg-4  mt-3 mt-md-0 mb-5">
          <div className="row d-flex justify-content-center ">
            <div className="col-3 mt-2 col-lg-5 mt-md-3 mt-lg-2">
              <Achievement
                quantity={user?.trophies?.mostAssists || 0}
                achievement="mostAssists"
              />
            </div>
            <div className="col-3 mt-2 col-lg-5 mt-md-3 mt-lg-2">
              <Achievement
                quantity={user?.trophies?.mostIntercepts || 0}
                achievement="mostIntercepts"
              />
            </div>
            <div className="col-3 mt-2 col-lg-5 mt-lg-3 mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.cleanSheets || 0}
                achievement="cleanSheets"
              />
            </div>
            <div className="col-3 mt-2 col-lg-5 mt-lg-3 mt-md-3 mt-lg-0">
              <Achievement
                quantity={user?.trophies?.mostHeaders || 0}
                achievement="mostHeaders"
              />
            </div>
          </div>
        </div>
      </div>
      </>
      : null}
    </Container>
  );
};

export default Achievements;

const Container = styled.div`
  /* min-height: 80vh; */
  background-color: rgb(50, 50, 50);
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  /* min-height: 80vh; */
  height: 95%;
  border: black 2px solid;
  position: relative;
  margin-top: 2rem;
  overflow: hidden;

  @media (min-width: 350px) {
    padding: 0 2rem;
  }
  @media (min-width: 567px) {
    padding: 0 5rem;
  }
  @media (min-width: 768px) {
    padding: 0 3rem;
  }
  @media (min-width: 991px) {
    padding: 0 5rem;
  }
  @media (min-width: 1200px) {
    padding: 0 8rem;
  }
`;

const DisplaySmall = styled.div`
  @media (min-width: 991px) {
    display: none;
  }
`;
const DisplayLarge = styled.div`
  @media (max-width: 991px) {
    display: none;
  }
  height: 100%;
`;
